export const STATUS_ALTERNATIVA_RAM = {
  CONFORMIDADE: "Conformidade",
  INCONFORMIDADE: "Não Conformidade",
  NEUTRO: "Neutro",
};
